/* eslint-disable @typescript-eslint/no-unused-vars */
import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import logo from '../../../assets/partners.svg';

const useStyles = makeStyles(({ spacing, palette }: Theme) => ({
  container: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },

  image: {
    width: '100%',
    height: '60%',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
  },

  text: {
    color: palette.neutral[100],
    marginTop: spacing(4),
    fontSize: '1.125rem',
  },
}));

export const NoContent = (): JSX.Element => {
  const styles = useStyles();

  return (
    <div className={styles.container}>
      <div className={styles.image} style={{ backgroundImage: `url(${logo})` }} />

      <div className={styles.text}>Não há parceiros cadastrados...</div>
    </div>
  );
};

export default NoContent;
